// @ts-nocheck
export const JSONDiff = (obj, obj2, except) => {
	for (let x in obj)
		if (
			(typeof obj2[x] === "undefined" || obj[x] !== obj2[x])
			&& (!except || except?.indexOf(x) === -1)
		)
			return (true);
	return (false);
};
